import { UserIcon } from "@heroicons/react/20/solid";

const UserProfilePhoto = ({ photoUrl, fullName }) => (
  <>
    {
      photoUrl
        ? <img src={photoUrl} className="h-[30px] w-[30px] rounded-full" alt={fullName} />
        : <div className="h-[30px] w-[30px] bg-gray-300 rounded-full">
          <UserIcon className="h-full w-full text-gray-500 mx-auto" />
        </div>
    }
  </>
)

export default UserProfilePhoto;
